import { useParams, Navigate } from 'react-router-dom';
import RepositoryBatchFileList from '../Repository/RepositoryBatchFileList';
import { useSubscription } from '../../hooks/useSubscription';

const DEFAULT_PAGE_SIZE = 10;

const RepositoryBatchFileListWrapper = () => {
    const { batch_id, repo_id } = useParams();
    const repositoryId = repo_id ? parseInt(repo_id) : null;
    const batchId = batch_id ? parseInt(batch_id) : null;
    const { isTrial, isActive } = useSubscription();

    // Redirect to pricing if Trial or inactive subscription
    if (isTrial || !isActive) {
        return <Navigate to="/pricing" replace />;
    }

    return <RepositoryBatchFileList pageSize={DEFAULT_PAGE_SIZE} repositoryId={repositoryId} batchId={batchId} />;
};

export default RepositoryBatchFileListWrapper;

